'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currentColor", "opacity"],
  _excluded2 = ["color", "icon", "menuWidth", "onColorChange", "onOpenChange", "onPickerModeChange", "onResetClick", "open", "tooltipPlacement", "tooltip", "DropdownContent", "disabled"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import SimpleStyledCaret from './internal/SimpleStyledCaret';
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { rgba } from 'UIComponents/core/Color';
import { callIfPossible } from 'UIComponents/core/Functions';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import Controllable from 'UIComponents/decorators/Controllable';
import UIAbstractDropdown from 'UIComponents/dropdown/abstract/UIAbstractDropdown';
import UITextToolbarIcon from '../editor/UITextToolbarIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { propType as colorPropType } from 'UIComponents/utils/propTypes/color';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTextToolbarIcon = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UITextToolbarIcon, Object.assign({}, rest, {
    size: 13
  }));
}).withConfig({
  displayName: "UITextToolbarColorDropdown__StyledTextToolbarIcon",
  componentId: "sc-1i5aayc-0"
})(["border-bottom:2px solid ", ";line-height:1;padding-bottom:1px;position:relative;transform:translateY(-2px);"], ({
  currentColor,
  opacity
}) => rgba(currentColor, opacity));
const COLORPICKER_SIMPLE_MODE = 'simple';
class UITextToolbarColorDropdownCore extends Component {
  constructor(props) {
    super(props);
    this.handleOpenChange = evt => {
      const {
        onOpenChange
      } = this.props;
      if (evt.target.value === true) {
        this.setState({
          pickerMode: COLORPICKER_SIMPLE_MODE
        });
      }
      onOpenChange(evt);
    };
    this.handleColorChange = update => {
      const {
        onColorChange,
        onOpenChange
      } = this.props;
      const {
        pickerMode
      } = this.state;
      onColorChange(SyntheticEvent(update));
      if (pickerMode === COLORPICKER_SIMPLE_MODE) {
        onOpenChange(SyntheticEvent(false));
      }
    };
    this.handlePickerModeChange = evt => {
      const {
        onPickerModeChange
      } = this.props;
      this.setState({
        pickerMode: evt.target.value
      });
      callIfPossible(onPickerModeChange, evt);
    };
    this.state = {
      pickerMode: COLORPICKER_SIMPLE_MODE
    };
  }
  render() {
    const _this$props = this.props,
      {
        color: currentColor,
        icon,
        menuWidth,
        onResetClick,
        open,
        tooltipPlacement,
        tooltip,
        DropdownContent,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    const {
      pickerMode
    } = this.state;
    const {
      color,
      alpha
    } = currentColor;
    const opacity = alpha != null ? alpha / 100 : 1;
    const renderedIcon = /*#__PURE__*/_jsx(StyledTextToolbarIcon, {
      currentColor: color,
      opacity: opacity,
      name: icon,
      disabled: disabled
    });
    return /*#__PURE__*/_jsx(UITooltip, {
      open: open ? false : undefined,
      placement: tooltipPlacement,
      title: tooltip,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(UIAbstractDropdown, Object.assign({
        Button: SimpleStyledClickable,
        buttonText: renderedIcon,
        caretRenderer: /*#__PURE__*/_jsx(SimpleStyledCaret, {
          className: "m-x-1"
        }),
        menuWidth: menuWidth,
        onOpenChange: this.handleOpenChange,
        open: open,
        disabled: disabled
      }, rest, {
        children: /*#__PURE__*/_jsx(DropdownContent, {
          alpha: alpha,
          color: color,
          pickerMode: pickerMode,
          onChange: this.handleColorChange,
          onOpenChange: this.handleOpenChange,
          onPickerModeChange: this.handlePickerModeChange,
          onResetClick: onResetClick
        })
      }))
    });
  }
}
UITextToolbarColorDropdownCore.propTypes = {
  color: PropTypes.shape({
    color: colorPropType,
    alpha: PropTypes.number
  }),
  DropdownContent: PropTypes.elementType.isRequired,
  icon: UITextToolbarIcon.propTypes.name,
  menuWidth: UIAbstractDropdown.propTypes.menuWidth,
  onColorChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  onPickerModeChange: PropTypes.func,
  onResetClick: PropTypes.func,
  open: PropTypes.bool.isRequired,
  tooltipPlacement: UITooltip.propTypes.placement,
  tooltip: UITooltip.propTypes.title,
  disabled: PropTypes.bool
};
UITextToolbarColorDropdownCore.defaultProps = {
  menuWidth: UIAbstractDropdown.defaultProps.menuWidth,
  open: false,
  tooltipPlacement: 'bottom'
};
UITextToolbarColorDropdownCore.displayName = 'UITextToolbarColorDropdownCore';
const UITextToolbarColorDropdown = Controllable(UITextToolbarColorDropdownCore, ['open', 'color']);
UITextToolbarColorDropdown.displayName = 'UITextToolbarColorDropdown';
export default UITextToolbarColorDropdown;